import { Pipe, PipeTransform } from '@angular/core';
import { STATUS_VINDICATION_LABELS, StatusVindicationCode } from '../vindication.model';

@Pipe({
	name: 'statusVindicationLabel',
	standalone: true,
	pure: true,
})
export class StatusVindicationLabelPipe implements PipeTransform {
	transform(value: StatusVindicationCode | null | undefined): string {
		if (!value) {
			return '—';
		}

		const original = String(value);
		const normalized = original.trim().toUpperCase();

		if (normalized in STATUS_VINDICATION_LABELS) {
			return STATUS_VINDICATION_LABELS[normalized as StatusVindicationCode];
		}

		return original;
	}
}
